"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M229.2 125.8v125c1.8 21.1-13.7 39.6-34.7 41.7h-34.7c-13.8-.5-25.8-9.1-30.8-21.9-2.7-6.2-4.1-13-4-19.8v-125c-.1-6.8 1.3-13.5 4-19.8 5-12.8 17-21.4 30.7-21.9h34.7c21.1 2.1 36.6 20.7 34.8 41.7zM83.4 125.8h20.8v125H83.4c-11.5 0-20.9-9.3-20.9-20.9v-83.2c0-11.5 9.3-20.9 20.9-20.9zM145.8 313.3h62.5v104.1c0 11.6-9.4 20.9-20.9 20.9h-20.8c-11.5 0-20.8-9.3-20.8-20.8V313.3z"
  }), (0, _core.jsx)("path", {
    d: "M437.5 62.5v251.7c-61.6-41.4-134.1-63.4-208.3-63.3v-125c74.2 0 146.7-22 208.3-63.4z"
  }));
};

exports.default = _default;